import React from 'react';
// import { Appbar as MaterialButton } from '@material-ui/core';
import MaterialAppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import { ThemeColors } from '../../theme';

function AppBar(props) {
  const { classes } = props;
  const typStyle = props.defaultTypography
  ? { fontSize: 24,
    textAlign: 'center',
    textTransform: 'uppercase' }
  : props.typography;

  const className = props.defaultTypography
  ? classes.defaultStyle
  : '';

  const colorProps = {
    color: ThemeColors.darkTextOnPrimaryBackground
          ? 'black'
          : 'white',
  };

  if (!props.defaultTypography) colorProps.color = 'black';

  const drawerIcon = props.showMenuIconButton
    ? (
      <IconButton
        edge="start"
        className={classes.menuButton}
        onClick={props.onLeftIconButtonClick}
        color="inherit"
        aria-label="open drawer"
      >
        <MenuIcon />
      </IconButton>
    )
    : null;

  return (
    <MaterialAppBar
      elevation={props.elevation}
      position={props.position}
      className={className}
      style={{
        ...props.style,
        ...colorProps,
      }}
    >
      <Toolbar className={className} style={props.toolBarStyle}>
        {drawerIcon}
        <Typography style={typStyle}>
          {props.title}
        </Typography>
        {props.children}
      </Toolbar>

    </MaterialAppBar>
  );
}

AppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  elevation: PropTypes.number,
  position: PropTypes.string,
  toolBarStyle: PropTypes.object,
  typography: PropTypes.object,
  title: PropTypes.string,
  defaultTypography: PropTypes.bool,
  children: PropTypes.any,
  style: PropTypes.object,
  showMenuIconButton: PropTypes.bool,
  onLeftIconButtonClick: PropTypes.func,
};

AppBar.defaultProps = {
  elevation: 2,
  position: 'static',
  typography: null,
  title: '',
  defaultTypography: false,
  children: null,
  toolBarStyle: null,
  style: null,
  showMenuIconButton: false,
  onLeftIconButtonClick: () => {},
};

const styles = () => ({
  defaultStyle: {
    textAlign: 'center',
    height: 64,
    justifyContent: 'center',
    display: 'flex',
  },
});

export default withStyles(styles)(AppBar);



// WEBPACK FOOTER //
// ./src/app/components/appbar/appbar.js